// Report-wide, not per-row: a type absent from one row still gets a column if any other row
// in the same result set carries it. Sorted by timeTypeId, which matches catalog order.
export const getPresentTypeSummaries = (rows) => {
  const byId = new Map()
  rows.forEach(row => {
    ;(row.typeSummaries || []).forEach(typeSummary => {
      if (!byId.has(typeSummary.timeTypeId)) {
        byId.set(typeSummary.timeTypeId, { timeTypeName: typeSummary.timeTypeName, isTimeOff: typeSummary.isTimeOff === true })
      }
    })
  })
  return Array.from(byId.entries())
    .sort((a, b) => a[0] - b[0])
    .map(([timeTypeId, { timeTypeName, isTimeOff }]) => ({ timeTypeId, timeTypeName, isTimeOff }))
}

export default getPresentTypeSummaries
